const ChainIcon = ({ clr }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={12}
    height={12}
    fill="none"
    className="object-cover"
  >
    <g fill="#42BE40" clipPath="url(#a)">
      <path d="M10.191 10.192a3.38 3.38 0 0 0-.048-2.768c-.16-.32-.368-.64-.64-.896a3.828 3.828 0 0 0-.896-.64l-.48.48a1.114 1.114 0 0 0-.288 1.024c.176.08.336.192.48.336.144.144.256.304.336.48.08.192.129.384.144.592.032.464-.128.928-.48 1.28l-3.424 3.36a1.66 1.66 0 0 1-2.336 0 1.661 1.661 0 0 1 0-2.336l2.64-2.64a3.846 3.846 0 0 1-.128-2.208c-.112.08-.208.176-.32.272L1.375 9.904A3.316 3.316 0 0 0 .4 12.272c0 .848.32 1.712.976 2.352 1.296 1.296 3.408 1.296 4.72 0l3.392-3.392c.096-.096.192-.208.272-.32.177-.224.32-.464.432-.72Z" />
      <path d="M15.6 3.728a3.28 3.28 0 0 0-.976-2.352c-1.296-1.296-3.408-1.296-4.72 0L6.512 4.768a2.616 2.616 0 0 0-.272.32c-.176.224-.32.464-.432.72a3.38 3.38 0 0 0 .048 2.768c.16.32.368.64.64.896.272.272.576.48.896.64l.48-.48c.272-.272.368-.672.288-1.024a1.628 1.628 0 0 1-.48-.336 1.63 1.63 0 0 1-.336-.48A1.886 1.886 0 0 1 7.2 7.2a1.636 1.636 0 0 1 .48-1.28l3.424-3.36a1.66 1.66 0 0 1 2.336 0c.64.64.64 1.696 0 2.336l-2.656 2.656c.256.704.304 1.472.128 2.208.112-.08.208-.176.32-.272l3.392-3.392a3.317 3.317 0 0 0 .976-2.368Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default ChainIcon;
